const USER_KEY = "aw_user";
const TOKEN_KEY = "aw_token";
const AUTH_TOKEN_EXPIRY_KEY = "authTokenExpiry";
const AUTH_TOKEN_REFRESH_UNTIL_KEY = "authTokenRefreshUntil";

const getLocalStorage = () => {
    // Using sessionStorage means the session is cleared when the tab is closed.
    // If you want persistence across browser sessions, change this to `localStorage`.
    return sessionStorage;
};

// Logged User
const getLoggedInUser = () => {
    const user = getLocalStorage().getItem(USER_KEY);
    return user && user !== 'undefined' ? JSON.parse(user) : null;
};
const setLoggedInUser = user => {
    getLocalStorage().setItem(USER_KEY, JSON.stringify(user));
};
const clearLoggedInUser = () => {
    getLocalStorage().removeItem(USER_KEY);
};

// Auth Token (JWT)
const getAuthToken = () => {
    const token = getLocalStorage().getItem(TOKEN_KEY);
    return token && token !== 'undefined' ? token : null;
};
const setAuthToken = token => {
    getLocalStorage().setItem(TOKEN_KEY, token);
};

// Auth Token Expiry
const setAuthTokenExpiry = (expiry) => {
    getLocalStorage().setItem(AUTH_TOKEN_EXPIRY_KEY, expiry);
};
const getAuthTokenExpiry = () => {
    const expiry = getLocalStorage().getItem(AUTH_TOKEN_EXPIRY_KEY);
    return expiry ? parseInt(expiry, 10) : null;
};

// Auth Token Refresh Until
const setAuthTokenRefreshUntil = (refreshUntil) => {
    getLocalStorage().setItem(AUTH_TOKEN_REFRESH_UNTIL_KEY, refreshUntil);
};
const getAuthTokenRefreshUntil = () => {
    const refreshUntil = getLocalStorage().getItem(AUTH_TOKEN_REFRESH_UNTIL_KEY);
    return refreshUntil ? parseInt(refreshUntil, 10) : null;
};

// Clearers
const clearAuthToken = () => {
    getLocalStorage().removeItem(TOKEN_KEY);
    getLocalStorage().removeItem(AUTH_TOKEN_EXPIRY_KEY);
    getLocalStorage().removeItem(AUTH_TOKEN_REFRESH_UNTIL_KEY);
};
const clearLoggedInUserAndToken = () => {
    clearLoggedInUser();
    clearAuthToken();
};

const LocalStorageManager = {
    getLoggedInUser,
    setLoggedInUser,
    clearLoggedInUser,
    getAuthToken,
    setAuthToken,
    setAuthTokenExpiry,
    getAuthTokenExpiry,
    setAuthTokenRefreshUntil,
    getAuthTokenRefreshUntil,
    clearAuthToken,
    clearLoggedInUserAndToken,
};

export default LocalStorageManager;